import React from 'react';
import RecipientsListTopAvatarLineDF
  from '../components/SimulatorsComponents/DefualtSimulators/RecipientsListTopAvatarLineDF';

const Sim_G02_SplitPaymentRecipientsList = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs,
}) => (
  <RecipientsListTopAvatarLineDF
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
  />
);
export default Sim_G02_SplitPaymentRecipientsList;
